var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3057_15054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13.125C5.37555 13.125 3.81763 12.4797 2.66897 11.331C1.52031 10.1824 0.875 8.62445 0.875 7C0.875 5.37555 1.52031 3.81763 2.66897 2.66897C3.81763 1.52031 5.37555 0.875 7 0.875C8.62445 0.875 10.1824 1.52031 11.331 2.66897C12.4797 3.81763 13.125 5.37555 13.125 7C13.125 8.62445 12.4797 10.1824 11.331 11.331C10.1824 12.4797 8.62445 13.125 7 13.125ZM7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81371 5.7645L5.80996 6.01562L5.73821 6.34812L6.13196 6.42075C6.38921 6.482 6.43996 6.57475 6.38396 6.83113L5.73821 9.86562C5.56846 10.6505 5.83008 11.0197 6.44521 11.0197C6.92208 11.0197 7.47596 10.7993 7.72708 10.4965L7.80408 10.1325C7.62908 10.2865 7.37358 10.3478 7.20383 10.3478C6.96321 10.3478 6.87571 10.1789 6.93783 9.88138L7.81371 5.7645ZM7.87496 3.9375C7.87496 4.16956 7.78277 4.39212 7.61868 4.55622C7.45458 4.72031 7.23202 4.8125 6.99996 4.8125C6.76789 4.8125 6.54533 4.72031 6.38124 4.55622C6.21715 4.39212 6.12496 4.16956 6.12496 3.9375C6.12496 3.70544 6.21715 3.48288 6.38124 3.31878C6.54533 3.15469 6.76789 3.0625 6.99996 3.0625C7.23202 3.0625 7.45458 3.15469 7.61868 3.31878C7.78277 3.48288 7.87496 3.70544 7.87496 3.9375Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3057_15054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.ab2370fea50f472abd656cd166cf3c70.svg";
export { ForwardRef as ReactComponent };